import { useThemeUI } from 'theme-ui';
import { get, pipe, defaultTo } from 'lodash/fp';
export var themeProp = function themeProp(str) {
  return function (props) {
    return get("theme." + str, props);
  };
};

if (typeof themeProp !== 'undefined' && themeProp && themeProp === Object(themeProp) && Object.isExtensible(themeProp) && !themeProp.hasOwnProperty('__filemeta')) {
  Object.defineProperty(themeProp, '__filemeta', {
    configurable: true,
    value: {
      name: "themeProp",
      filename: "node_modules/gatsby-theme-docz/src/utils/theme.js"
    }
  });
}

export var usePrismTheme = function usePrismTheme() {
  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme,
      colorMode = _useThemeUI.colorMode;

  var getTheme = pipe(get('prismTheme'), defaultTo(get("prism." + colorMode, theme)));
  return getTheme(theme);
};

if (typeof usePrismTheme !== 'undefined' && usePrismTheme && usePrismTheme === Object(usePrismTheme) && Object.isExtensible(usePrismTheme) && !usePrismTheme.hasOwnProperty('__filemeta')) {
  Object.defineProperty(usePrismTheme, '__filemeta', {
    configurable: true,
    value: {
      name: "usePrismTheme",
      filename: "node_modules/gatsby-theme-docz/src/utils/theme.js"
    }
  });
}